/* global $:true Foundation:true */
import debug from "debug";
import plugin from '../../lib/plugin';
import { tmpl } from '../../lib/strings';
import * as sliders from '../sliders';
import * as lazyLoad from '../lazy-load';

const MODULE_NAME = 'app.core/modules/quote';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-add-to-quote]';
const PROGRESS_CLASS = 'has-progress';
const PRODUCT_ID_ATTR = 'data-product-id';
const PRICE_ATTR = 'data-price';

//  todo pull these from CMS editable page somehow
const validationMessages = {
    // empty: 'What quantity would you like quoted?',
    // min: 'What quantity would you like quoted?',
    // max: 'Sorry you can’t order more than {{max}}',
    integer:
        $(`meta[name="site.addToQuoteValidation.integer"]`).attr('content') ||
        'Oops! Enter the number as digits only please.',
    connection:
        $(`meta[name="site.addToQuoteValidation.connection"]`).attr(
            'content'
        ) ||
        'An error occurred sending your request to the server. Please try again later.'
};

const quantityTests = [
    // {
    //     //  is not empty
    //     test: value => value !== '',
    //     message: 'empty'
    // },
    {
        // is integer
        test: value => Number.isInteger(value),
        message: 'integer'
    }
    // ,
    // {
    //     // is not less than min (1)
    //     test: value => value > 0,
    //     message: 'min'
    // }
    //  Max test not required at this time
    // ,{
    //     // is not more than max
    //     test: (value, max) => value <= max,
    //     message: `max`
    // }
];

function getMessage(messageName, context) {
    const message = validationMessages[messageName] || false;
    return context ? tmpl(message, context) : message;
}

//  Note the {max} value here is not needed
//  left as example of rendering a dynamic value into a error message
function validateQty(value, max) {
    const error = quantityTests.reduce((result, validator) => {
        return result
            ? result
            : validator.test(value, max)
				? false
				: getMessage(validator.message, { max });
    }, false);

    //  Return true or error message encountered
    return error;
}

class AddToQuotePlugin {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$code = this.$element.find('[name="code"]');
        this.codeVal = '';
        this.$qty = this.$element.find(`[name="${this.options.field}"]`);
        this.qtyVal = '';
        this.maxQty = this.$qty.attr('max');
        this.$custom = $('[name="length"]');
        this.customVal = '';
        this.$addToQuoteButton = this.$element.find(
            this.options.submitButton
        );
        this.productId = this.$element.attr(PRODUCT_ID_ATTR);
        this.price = this.$element.attr(PRICE_ATTR);

        this.$headerQuoteLink = $(this.options.quoteLink);
        this.$modal = $(this.options.modal);
        this.$productName = this.$element.find(this.options.productName);
        this.$modalProductTitle = $(this.options.modalProductTitle);
        this.$customSelectDisplay = $(this.options.customSelectDisplay);
        this.$optionPanel = $(this.options.optionPanel);
        this.$changeMarketSubmitButton = $(
            this.options.changeMarketSubmitButton
        );
        this.$errorElement = this.$element.find(this.options.errorElement);
        this.errorClassname = this.options.errorClassname;
        this.imageUrl = this.options.imageUrl;
        this.imageAlt = this.options.image;
        this.$modalProductImage = $(this.options.modalProductImage);
		this.$modalSuggestedProductsContainer = $(this.options.modalSuggestedProductsContainer);

		this.$productElement = this.$element.closest(this.options.productElementSelector);
		this.$productTickElement = this.$productElement.find(this.options.productTickSelector);

        log('AddToQuotePlugin', element);

        this.watch();
    }

    getErrors() {
        return validateQty(+this.$qty.val(), +this.maxQty);
    }

    onQtyInput(event) {
        //  ignore: enter, shift, alt, tab, meta key strokes (meta has multiple codes)
        const ignoreKeys = [13, 16, 18, 9, 91, 92, 93, 224];

        //  Ignore keystrokes with modifier key
        if (ignoreKeys.indexOf(event.which) !== -1) {
            return true;
        }

        const error = this.getErrors();

        if (error) {
            this.handleErrors([error], 'client');
        } else {
            this.clearErrors();
        }
    }

    onAddQtyExit() {
        const value = this.$qty.val().trim();

        // if value is emptish: '', '0'
        if (value === '' || value === '0') {
            this.clearErrors();
            this.$qty.val('');
        }
    }

    //  0 is a valid value for update form
    onUpdateQtyExit() {
        const value = this.$qty.val().trim();

        // if value is empty: ''
        if (value === '') {
            this.clearErrors();
            this.$qty.val('');
        }
    }

    catchEnter(event) {
        if (event.which === 13 /* enter */) {
            event.preventDefault();
            this.submit();
        }
    }

    //  Used on view quote page
    onSubmit(event) {
        this.codeVal = this.$code.val();

        this.customVal = this.getCustomValue(this.$custom);
        const error = this.getErrors();

        if (error) {
            event.preventDefault();
            this.handleErrors([error], 'client');
        }
    }

    onAjaxSubmit(event) {
        event.preventDefault();
        this.submit();
    }

    getCustomValue($input) {
        if (!$input.length) {
            return '0';
        }

        if ($input.is(':checkbox')) {
            return $input.is(':checked') && $input.val();
        }

        if ($input.hasClass('custom-select__value-input')) {
            var parentEl = $input.closest('.custom-select');

            return $(parentEl).find('button .custom-select__item-label').text().trim();
        }
        //  hidden input
        return $input.val();
    }

    submit() {
		this.codeVal = this.$code.val();

        //  If no quantity entered in the qty field - presume 1
        this.qtyVal = this.$qty.val() ? this.$qty.val() : '1';
        this.customVal = this.getCustomValue(this.$custom);
        const error = this.getErrors();

        if (error) {
            this.handleErrors([error], 'client');
            return false;
        }

        if (this.codeVal.length > 0) {
            log('submitted', this.$element);
            this.$addToQuoteButton
                .addClass(PROGRESS_CLASS)
                .attr('disabled', 'disabled');
            this.post();
        }
    }

    watch() {
        log('ajax', this.options.ajax);
        const submitHandler =
            this.options.ajax === true
                ? this.onAjaxSubmit.bind(this)
                : this.onSubmit.bind(this);

        const exitQtyInputHandler =
            this.options.type === 'add'
                ? this.onAddQtyExit.bind(this)
                : this.onUpdateQtyExit.bind(this);

        if (this.$element.is('form')) {
            this.$element.on('submit.addToQuote', submitHandler);
        } else {
            this.$addToQuoteButton.on(
                'click.addToQuote',
                this.onAjaxSubmit.bind(this)
            );

            //  avoid submitting containing product listing filter form
            this.$qty.on('keydown.addToQuote', this.catchEnter.bind(this));
        }

        this.$qty.on('keyup.addToQuote', this.onQtyInput.bind(this));
        this.$qty.on('blur.addToQuote', exitQtyInputHandler);
    }

    unwatch() {
        this.$element.off('.addToQuote');
        this.$addToQuoteButton.off('.addToQuote');
        this.$qty.off('.addToQuote');

        log('unbound', this.$element);
    }

    onSuccess(result) {
        this.$addToQuoteButton
            .removeClass(PROGRESS_CLASS)
            .removeAttr('disabled');

        if (typeof result.Success !== 'undefined' && result.Success) {
            if (typeof result.ItemsInCart !== 'undefined') {
                if (this.$headerQuoteLink.find('.count').length == 0) {
                    this.$headerQuoteLink.append(
                        '<span class="count">' + result.ItemsInCart + '</span>'
                    );
                } else {
                    this.$headerQuoteLink
                        .find('.count')
                        .html(result.ItemsInCart);
                }

				if(this.options.preventModal) {
					// add a tick to the product indicating it was added to cart
					this.$productTickElement.removeAttr('hidden');

				} else {
					this.openModal(this.$modal);
                    this.loadSuggestions();
				}
                this.resetForm(result.ItemsInCart);
                $( document ).trigger('added-to-cart',[this.productId, this.qtyVal, this.price, this.codeVal]);

                if (result.Cart && result.Cart.length) {

                    // Sales force tracking
                    this.element.dispatchEvent(
                        new CustomEvent("cart-updated", {
                            bubbles: true,
                            detail: result.Cart
                        })
                    );
                }
            }
        } else {
            var errorList =
                typeof result.ValidationMessages !== 'undefined'
                    ? result.ValidationMessages
                    : Array();
            log('addToQuoteServerError', errorList);
            this.handleErrors(errorList, 'server');
        }
    }

    setSliderHeights() {
        $(this.options.productSliderErrorParentClassname).css('padding-bottom', '0');
        var module = this;
        $(this.options.productSliderErrorClassname).each(function(){
            var messageHeight = $(this).outerHeight();

            $(this).closest(module.options.productSliderErrorParentClassname).css('padding-bottom', messageHeight);

        });

        if ($(this.options.productSliderErrorClassname).length > 0) {
            setTimeout(function(){
                var flkty = Flickity.data( $(module.options.productSliderClassname)[0]);
                flkty.resize();
            }, 10);
        }
    }

    handleErrors(errorList, errorSource) {
        const errorMessage = errorList.join(' ');
        const submitErrorClass =
            errorSource == 'submit' ? this.options.submitErrorClassname : '';
        if (this.$errorElement.length > 0) {
            this.$errorElement.empty().append(errorMessage);
            this.setSliderHeights();
        }

        this.$qty.addClass(`${this.errorClassname} ${submitErrorClass}`);
    }

    clearErrors() {
        this.$qty.removeClass(
            `${this.errorClassname} ${this.options.submitErrorClassname}`
        );
        this.$errorElement.empty();
    }

    resetForm(itemsInQuote) {
        this.$qty.val('').trigger('keyup');

        this.clearErrors();

        if (this.$custom.length > 0) {
            this.$custom.removeAttr('checked');
            this.$customSelectDisplay.removeAttr('disabled');
        }
        if (this.$optionPanel.length > 0) {
            this.$optionPanel.removeClass('is-customised');
        }

        if (this.$changeMarketSubmitButton.length > 0 && itemsInQuote > 0) {
            if (this.$changeMarketSubmitButton.attr('type') == 'submit') {
                this.$changeMarketSubmitButton.attr('type', 'button');
                this.$changeMarketSubmitButton.attr(
                    'data-open',
                    'market-change-confirm-modal'
                );
            }
        }
    }

    openModal(modal) {
        this.$modalProductTitle.html(this.$productName.val());
        this.$modalProductImage.attr('src', this.imageUrl);
        this.$modalProductImage.attr('alt', this.imageAlt);
        modal.foundation('open');
    }

    post() {
        const url = `${this.options.endpointUrl}?${this.options
            .endpointParam}=${this.codeVal}&${this.options
            .endpointParam2}=${this.customVal}&${this.options
            .endpointParam3}=${this.qtyVal}`;

        var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

        log('accepting', this.$element, url);
        $.ajax({
            url,
            method: 'post',
            data: {
                __RequestVerificationToken: token
            },
            success: result => {
                this.onSuccess(result);
            },
            error: e => {
                log('addToQuoteAjaxError', e);
                this.$addToQuoteButton
                    .removeClass(PROGRESS_CLASS)
                    .removeAttr('disabled');
                this.handleErrors([validationMessages.connection], 'submit');
            }
        }).done(() => {
            log('accepted', this.$element, url);
        });
    }

    loadSuggestions() {
    	const url = `${this.options.suggestedProductsEndpointUrl}?${this.options
            .endpointParam}=${this.codeVal}`;
        this.$modalSuggestedProductsContainer.empty();
		log('accepting', this.$element, url);
		var myModal = this.$modal;
        $.ajax({
            url,
            method: 'post',
            success: result => {
				this.$modalSuggestedProductsContainer.html(result);
				// prevent flash of un-slidered content by making the slider invisible
				this.$modalSuggestedProductsContainer.css('visibility','hidden');

				setTimeout(() => {
					// make the slider content visible again
					this.$modalSuggestedProductsContainer.css('visibility','');
					// initialise the slider
					sliders.exec();
					// ensure that the reveal window recalculates it's size/position
					myModal.foundation('open');
					// ensure that the buy buttons work
                    this.initialiseOnDynamicContent();
                    //STRONE-976 - ensure suggested product images load
                    lazyLoad.exec();
            	}, 100);
            },
            error: e => {
                log('loadSuggestionsError', e);
            }
        }).done(() => {
            log('accepted', this.$element, url);
        });
	}

	initialiseOnDynamicContent() {
		this.$modalSuggestedProductsContainer.find(ELEMENT_SELECTOR).addToQuote();
	}
}

AddToQuotePlugin.DEFAULTS = {
    field: 'qty',
    type: 'add',
    endpointUrl: $(`meta[name="site.addToCartApiEndpoint"]`).attr('content'),
    suggestedProductsEndpointUrl: $(`meta[name="site.suggestedProductsApiEndpoint"]`).attr('content'),
    endpointParam: 'code',
    endpointParam2: 'length',
    endpointParam3: 'qty',
    productName: '[name="productName"]',
    modalProductTitle: '#added-to-cart__title',
    quoteLink: '#header-cart-link',
    modal: '#added-to-cart-modal',
    optionPanel: '#option_panel',
    customSelectDisplay: '.custom-select__display',
    changeMarketSubmitButton: '#marketChangeButton',
    submitButton: '[type="submit"]',
    errorElement: '.error-message',
    errorClassname: 'error',
    submitErrorClassname: 'submit-error',
    productSliderClassname: '.block-product-slider',
    productSliderErrorClassname: '.block-product-slider .error-message',
    productSliderErrorParentClassname: '.block-product-slider .product-teaser__content',
    modalSuggestedProductsContainer:'#added-to-cart-suggested-products',
	modalProductImage: '#added-to-cart__img',
	productElementSelector: '.product-teaser',
	productTickSelector: '.product-teaser__tick',
};

plugin('addToQuote', AddToQuotePlugin);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).addToQuote();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/quote/index.js